import url from '../../utils/url';

export default class ParameterReplacementTextblock {
    constructor(domRoot: HTMLElement, params: any) {
        this.doTextReplacement(
            domRoot.querySelector('.parameter-replacement-container') as HTMLElement,
            params
        );
    }

    doTextReplacement(
        replacementContainer: { innerHTML: any; },
        { whitelist, paramName, replacementVariable, replacementText }: any
    ) {
        const { [paramName]: urlParam } = url.getUrlParams() || {};
        const { [urlParam]: whitelistValue } = whitelist || {};

        if (whitelistValue) {
            replacementContainer.innerHTML =
                replacementText.replace(new RegExp(replacementVariable, 'g'), whitelistValue);
        }
    }
}
